import * as stylex from '@stylexjs/stylex'
import { colors } from '../tokens/colors.stylex'

export const ppColors = {
  brand: '#000000',
  primary50: '#F6FBFD',
  primary100: '#E8FBFF',
  primary200: '#C8EFF9',
  primary300: '#A9E1F2',
  primary400: '#8BD2EC',
  primary500: '#6FC2E5',
  primary600: '#33A1D9',
  primary700: '#3589BA',
  primary800: '#1C6596',
  primary900: '#0B4571',

  secondary50: '#FAFAFA',
  secondary100: '#F5F5F5',
  secondary200: '#EEEEEE',
  secondary300: '#E1E1E1',
  secondary400: '#BEBEBE',
  secondary500: '#9E9E9E',
  secondary600: '#757575',
  secondary700: '#616161',
  secondary800: '#424242',
  secondary900: '#212121',
}

export const colorTheme = stylex.createTheme(colors, ppColors)
